import { MutationTree } from 'vuex'
import { RootState, SearchDataInterface } from '@/store/RootState'
import { Page, Resource, UserLocation } from '@/config/interfaces'

export const mutations: MutationTree<RootState> = {
  setMainData (state, items) {
    state.navigation = items.navigation || null
    if (
      Object.prototype.hasOwnProperty.call(items, 'header') &&
      Object.prototype.hasOwnProperty.call(items.header, 'buttons')
    ) {
      state.headerData = items.header.buttons
        .filter((btn: { uri: string }) => !btn.uri.includes('admin') && !btn.uri.includes('customer-info') && !btn.uri.includes('search')) || null
      state.unreadMessages = items.header.buttons
        .filter((btn: { uri: string }) => btn.uri.includes('notifications'))[0]?.inboxButton || 0
    }
    state.stickyPage = items.stickyPage || null
    state.viewActive = 'main'
    state.viewContent = ''
    state.pageData = items.pages || (items.groups && [{ groups: items.groups }])
    state.currentNavigationKey = ''
  },
  setPageData (state, payload: Array<Page>) {
    state.viewActive = 'main'
    state.viewContent = ''
    state.pageData = payload
  },
  toggleViewState (state, view) {
    if (state.viewActive !== view) {
      state.viewActive = view
    }
  },
  setViewContent (state, cardContent: Record<string, unknown> | string) {
    state.viewContent = cardContent
  },
  setLeftViewState (state, visible: boolean) {
    state.leftViewActive = visible
  },
  setLeftViewContent (state, leftContent: Record<string, unknown> | string) {
    state.leftViewContent = leftContent
  },
  setCardBackground (state, background: string) {
    state.cardBackground = background
  },
  setLeftViewTitle (state, title: string) {
    state.leftViewTitle = title
  },
  setPostParams (state, postParams: URLSearchParams | null) {
    state.postParams = postParams
  },
  setUserLocation (state, userLocation: UserLocation) {
    state.userLocation = userLocation
  },
  setIdentifier (state, identifier: Resource) {
    state.msisdn = identifier
  },
  setToken (state, token: string) {
    state.token = token
  },
  setLastLoggedInUser (state, lastLoggedInUser: string) {
    state.lastLoggedInUser = lastLoggedInUser
  },
  setHasPin (state, hasPin: boolean) {
    state.hasPin = hasPin
  },
  setCurrentNavigationKey (state, key: string) {
    state.currentNavigationKey = key
  },
  setAllowResend (state, allow: boolean) {
    state.allowResend = allow
  },
  setIdentifiers (state, identifiers: Array<Resource>) {
    state.msisdns = identifiers
    state.msisdn = identifiers.filter(item => item.active)[0]
  },
  setIdentifiersBundles (state, identifiers: Array<Array<Resource>>) {
    state.msisdnsBundles = identifiers
    identifiers.forEach(identifierBundle => {
      const active = identifierBundle.find(item => item.active)
      if (active) {
        state.msisdn = active
      }
    })
  },
  setRefreshLeftView (state, refresh: boolean) {
    state.refreshLeftView = refresh
  },
  setBillValues (state, billValues: Array<string>) {
    state.billValues = billValues
  },
  setJumpOnCloseURI (state, jumpOnCloseURI: string) {
    state.jumpOnCloseURI = jumpOnCloseURI
  },
  setAudio (state, audio: HTMLAudioElement) {
    state.audio = audio
  },
  setRootElClasses (state, rootElClasses: string) {
    state.rootElClasses = rootElClasses
  },
  setSearchVisible (state, searchVisible: boolean) {
    state.searchVisible = searchVisible
  },
  setSearchData (state, searchData: SearchDataInterface|null) {
    state.searchData = searchData
  },
  setCurrentUserAvatar (state, currentUserAvatar: string) {
    state.currentUserAvatar = currentUserAvatar
  }
}
